import { render, staticRenderFns } from "./SplitLayout.vue?vue&type=template&id=f65428b8&scoped=true"
import script from "./SplitLayout.vue?vue&type=script&lang=js"
export * from "./SplitLayout.vue?vue&type=script&lang=js"
import style0 from "./SplitLayout.vue?vue&type=style&index=0&id=f65428b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65428b8",
  null
  
)

export default component.exports